import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.phoneVerificationUserRegistration.pageTitle',
    defaultMessage: 'Verifica numero cellulare',
    description: 'Title of the phone verification user registration page',
  },
  pageSubtitle: {
    id: 'features.phoneVerificationUserRegistration.pageSubtitle',
    defaultMessage:
      'Inserisci il codice che è stato inviato al numero di cellulare scelto',
    description: 'Subtitle of the phone verification user registration page',
  },
  labelInsertPhoneNumberInputTextDisabled: {
    id: 'features.phoneVerificationUserRegistration.labelInsertPhoneNumberInputTextDisabled',
    defaultMessage: 'Numero di cellulare',
    description: 'Label of phone input text',
  },
  labelInsertCodeVerificationInputText: {
    id: 'features.phoneVerificationUserRegistration.labelInsertCodeVerificationInputText',
    defaultMessage: 'Codice di verifica',
    description: 'Label of verification code input text',
  },
  placeholderInsertCodeVerificationInputText: {
    id: 'features.phoneVerificationUserRegistration.placeholderInsertCodeVerificationInputText',
    defaultMessage: 'Inserisci il tuo codice di verifica',
    description: 'Placeholder of verification code input text',
  },
  descriptionDisclaimer: {
    id: 'features.phoneVerificationUserRegistration.descriptionDisclaimer',
    defaultMessage:
      'In caso di mancata ricezione dell’SMS, è possibile contattare telefonicamente il servizio di assistenza dedicato, al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Text of description disclaimer',
  },
  buttonVerificationCodeByMail: {
    id: 'features.phoneVerificationUserRegistration.buttonVerificationCodeByMail',
    defaultMessage: 'Verifica',
    description:
      'Label of the phone verification user registration button verification code',
  },
  errorWrongCode: {
    id: 'features.phoneVerificationUserRegistration.errorWrongCodeFirstPart',
    defaultMessage:
      'Il codice inserito non è corretto. Riprova. Tentativi rimasti: {attempts}',
    description: 'Error wrong code verification phone number ',
  },
  errorPhoneNumberNotUsableTitle: {
    id: 'features.phoneVerificationUserRegistration.errorPhoneNumberNotUsableTitle',
    defaultMessage: 'Attenzione!',
    description:
      'Error title phone number not usable verification phone number ',
  },
  errorPhoneNumberNotUsableMessages: {
    id: 'features.phoneVerificationUserRegistration.errorPhoneNumberNotUsable',
    defaultMessage:
      'Il numero di cellulare risulta già associato ad un altro contratto My Azimut. Si prega di inserire un altro numero di cellulare',
    description:
      'Error message phone number not usable verification phone number ',
  },
  errorPhoneNumberNotUsableButtonLabel: {
    id: 'features.phoneVerificationUserRegistration.errorPhoneNumberNotUsableButtonLabel',
    defaultMessage: 'Ok',
    description:
      'Label button error phone number not usable verification phone number ',
  },
  errorTooManyAttemptsTitle: {
    id: 'features.phoneVerificationUserRegistration.errorTooManyAttemptsTitle',
    defaultMessage: 'Attenzione!',
    description:
      'Title error too many attempts for dialog phone number verification page ',
  },
  errorTooManyAttemptsMessage: {
    id: 'features.phoneVerificationUserRegistration.errorTooManyAttempts',
    defaultMessage:
      'Attenzione! Hai raggiunto il limite di tentativi disponibili per verificare il numero di cellulare inserito. Inserisci nuovamente il numero per procedere con la verifica.',
    description:
      'Error message too many attempts for dialog phone number verification page ',
  },
  errorTooManyAttemptsButtonLabel: {
    id: 'features.phoneVerificationUserRegistration.errorTooManyAttemptsButtonLabel',
    defaultMessage: 'Ok',
    description:
      'Label button error too many attempts for dialog phone number verification page ',
  },
  errorAccordoQuadroNonAttivo: {
    id: 'features.phoneVerificationUserRegistration.errorAccordoQuadroNonAttivo',
    defaultMessage:
      'Attenzione! Impossibile procedere con la registrazione per accordo quadro non attivo.',
    description:
      'Error message accordo quadro not active',
  },
  errorInvalidPhoneNumberFormat: {
    id: 'features.phoneVerificationUserRegistration.errorInvalidPhoneNumberFormat',
    defaultMessage: 'INumero di cellulare non corretto. Si prega di controllare.',
    description: 'Error message for invalid phone number format in phone verification user registration page',
  },
});
